import { Suspense, lazy } from 'react'
import { WalletContextProvider } from './contexts/WalletContextProvider'
import Navbar from './components/Navbar/Navbar'
import Hero from './components/Hero/Hero'
import Features from './components/Features/Features'
import Architecture from './components/Architecture/Architecture'
import Quickstart from './components/Quickstart/Quickstart'
import SDKs from './components/SDKs/SDKs'
import DeepFeatures from './components/DeepFeatures/DeepFeatures'
import CTA from './components/CTA/CTA'
import Footer from './components/Footer/Footer'

// Lazy load the heavy 3D component
const ParticleField = lazy(() => import('./components/Background/ParticleField'))

function App() {
  return (
    <WalletContextProvider>
      {/* 3D Particle Background */}
      <Suspense fallback={<div className="canvas-container" />}>
        <ParticleField />
      </Suspense>

      {/* Main Content */}
      <div className="main-content">
        <Navbar />
        <Hero />
        <Features />
        <Architecture />
        <Quickstart />
        <SDKs />
        <DeepFeatures />
        <CTA />
        <Footer />
      </div>
    </WalletContextProvider>
  )
}

export default App
